import { ref } from "vue"
import { MenuItemObject } from "components/Wysiwyg/menu/MenuItem.vue"

export function useWysiwygAddon(
  title: string,
  icon: string,
  initialActive = false
) {
  const badgeCount = ref(0)
  const addonKey = ref(1)
  const addonActive = ref(initialActive)

  const resetAddon = () => {
    badgeCount.value = 0
    addonKey.value += 1
  }

  const setBadgeCount = (count: number) => {
    badgeCount.value = count
  }

  const addonMenuItem: MenuItemObject = {
    title: title,
    icon: icon,
    action: () => {
      addonActive.value = !addonActive.value
    },
    isActive: () => addonActive.value,
    badge: badgeCount,
  }

  return {
    addonKey,
    setBadgeCount,
    resetAddon,
    addonActive,
    addonMenuItem,
  }
}
